import React from 'react';
import { fromUnixTime, getUnixTime } from 'date-fns';

import Grid from '@mui/material/Grid';

import DebriefDatePicker from 'ff/debrief/components/DebriefDatePicker';
import SearchTermFilter from 'ff/debrief/components/sidebar/SearchTermFilter';

interface Props {
    startTimestamp: number;
    endTimestamp: number;
    fuzzySearchTerm: string;
    onStartChange: (timestamp: number) => void;
    onEndChange: (timestamp: number) => void;
    onFuzzySearchChange: (term: string) => void;
}

const FilterBar: React.FC<Props> = props => {
    const startDate = props.startTimestamp
        ? fromUnixTime(props.startTimestamp)
        : undefined;
    const endDate = props.endTimestamp
        ? fromUnixTime(props.endTimestamp)
        : undefined;

    const handleStartSave = (date: Date) => {
        const timestamp = getUnixTime(date);
        props.onStartChange(timestamp);
    };

    const handleEndSave = (date: Date) => {
        const timestamp = getUnixTime(date);
        props.onEndChange(timestamp);
    };

    const handleSearchTermSave = (searchTerm: string) => {
        props.onFuzzySearchChange(searchTerm);
    };

    return (
        <Grid columnSpacing={0.5} mt={0.5} px={0.5} container>
            <Grid xs={6} item>
                <DebriefDatePicker
                    date={startDate}
                    onChange={handleStartSave}
                    label="Start Date"
                    name="startDate"
                />
            </Grid>
            <Grid xs={6} item>
                <DebriefDatePicker
                    date={endDate}
                    onChange={handleEndSave}
                    label="End Date"
                    name="endDate"
                />
            </Grid>
            <Grid xs={12} item mt={0.5}>
                <SearchTermFilter
                    fuzzySearchTerm={props.fuzzySearchTerm}
                    onFuzzySearchChange={handleSearchTermSave}
                />
            </Grid>
        </Grid>
    );
};

export default FilterBar;
